import React, { useContext, useEffect, useState } from "react";
import { languages } from "../../../Data/languages";
import { ReactComponent as SEARCHICON } from "../../../assets/icons/search.svg";
import { NotificationContext } from "../../../Context/NotificationContext";

const LanguageFilter = ({ setShowModal, setSelectedLanguageFilter, selectedLanguageFilter,isLast }) => {
  const [searchTo, setSearchTo] = useState("");
  const [searchFrom, setSearchFrom] = useState("");
  const getLanguage = (value) => {
    return languages.find(l => l.value === value) || "";
  }
  const [selectedFilter, setSelectedFilter] = useState(
    {
      languageFrom : getLanguage(selectedLanguageFilter.languageFrom),
      languageTo: getLanguage(selectedLanguageFilter.languageTo)
    });

  const {showNotification} = useContext(NotificationContext)

  useEffect(()=> {
    if(selectedFilter.languageFrom && selectedFilter.languageFrom.value && selectedFilter.languageFrom.value !== "english"
      && !selectedFilter.languageTo
    ){
      setSearchTo("english");
    }
    
    if(selectedFilter.languageTo && selectedFilter.languageTo.value && selectedFilter.languageTo.value !== "english"
      && !selectedFilter.languageFrom
    ){
      setSearchFrom("english");
    }

  }, [selectedFilter])

  const handleApply = () => {
    if(selectedFilter.languageFrom && selectedFilter.languageTo){
        setSelectedLanguageFilter({languageFrom: selectedFilter.languageFrom.value, languageTo: selectedFilter.languageTo.value});
        setShowModal("");
    }else{
        showNotification("error", "Please select both languageFrom & LanguageTo to apply this filter.", "error")
    }
  };

  const handleClear = () => {
    setSelectedLanguageFilter({languageFrom: "", languageTo: ""});
    setSelectedFilter({languageFrom: "", languageTo: ""});
    setShowModal("");
  };

  return (
    <div className={`languageDetailsFilterPopup ${isLast ?"lg:left-0  md:left-[-13.5rem] left-0" :" w-fit lg:left-0 md:-right-1/2 right-0"}`}>
      <div className="accountLanguageFilterWrap md:flex-row flex-col">
        <div className="accountLanguagefilterItemsWrap">
          <div className="accountLanguageFilterSearch">
            <input
              className="accountLanguageFilterSearchInput"
              placeholder="Search"
              value={searchFrom}
              onChange={(e) => setSearchFrom(e.target.value)}
            />
            <SEARCHICON className="accountLanguageFilterSearchIcon" />
          </div>
          <div className="accountDeatilsFilterItems" style={{marginLeft: "0.5rem"}}>
            {languages.filter(l => l.label.toLowerCase().includes(searchFrom.toLowerCase())).map((l) => (
              <p key={l.value} className={`accountLanguageFilterText ${selectedFilter.languageFrom === l ? "accountLanguageselectedText" : ""}`}  onClick={() => setSelectedFilter(s => ({languageTo: s.languageTo, languageFrom : l}))}>{l.label}</p>
            ))}
          </div>
        </div>

        <p className="accountLanguageFilterText accountLanguageFilterToText">To</p>
        <div className="accountLanguagefilterItemsWrap">
          <div className="accountLanguageFilterSearch">
            <input
              className="accountLanguageFilterSearchInput"
              placeholder="Search"
              value={searchTo}
              onChange={(e) => setSearchTo(e.target.value)}
            />
            <SEARCHICON className="accountLanguageFilterSearchIcon" />
          </div>
          <div className="accountDeatilsFilterItems">
            {languages.filter(l => l.label.toLowerCase().includes(searchTo.toLowerCase())).map((l) => (
              <p  key={l.value} className={`accountLanguageFilterText ${selectedFilter.languageTo === l ? "accountLanguageselectedText" : ""}`} onClick={() => setSelectedFilter(s => ({languageTo: l, languageFrom : s.languageFrom}))}>{l.label}</p>
            ))}
          </div>
        </div>
      </div>

      {selectedFilter.languageTo !== "" || selectedFilter.languageFrom !== "" ? <div className="accountDateFilterFooterWrap">
        <div className="accountDetailDateTextWrap">
          {selectedFilter.languageFrom !== "" && <p className="accountDetailDateText">{selectedFilter.languageFrom.label}</p>}
          {selectedFilter.languageTo !== "" && selectedFilter.languageFrom !== "" && <p className="accountDetailDateText" style={{color: "#686F7B"}}>{">"}</p>}
          {selectedFilter.languageTo !== "" && <p className="accountDetailDateText">{selectedFilter.languageTo.label}</p>}
        </div>

        <div className="accountDetailsDateFilterFooterBtns">
        <button className="accountOrderBtn accountClearBtn" onClick={() => {handleClear()}}>Clear</button>
        <button disabled={selectedFilter.languageFrom === "" || selectedFilter.languageTo === ""} className="accountOrderBtn" onClick={() => {handleApply()}}>Apply</button>
        </div>
      </div> : <div className="accountDetailsFilterPopupBtns">
        <button className="accountOrderBtn accountClearBtn" onClick={() => {handleClear()}}>Clear</button>
        <button disabled={selectedFilter.languageFrom === "" || selectedFilter.languageTo === ""} className="accountOrderBtn" onClick={() => {handleApply()}}>Apply</button>
    </div>}
    </div>
  );
};

export default LanguageFilter;
